import cns from './cns';
import cnt from './cnt';
import en from './en'

export default{
    en:en,
    cns:cns,
    cnt:cnt
}